interface ToastServiceMethods {
	add: (message: {
		detail?: string;
		life?: number;
		severity: 'error' | 'info' | 'success' | 'warn';
		summary: string;
	}) => void;
}

class NotifyService {
	private toast: ToastServiceMethods | null = null;

	register(toast: ToastServiceMethods): void {
		this.toast = toast;
	}

	success(message: string, detail?: string): void {
		this.toast?.add({ detail, life: 3000, severity: 'success', summary: message });
	}

	error(message: string, detail?: string): void {
		this.toast?.add({ detail, life: 5000, severity: 'error', summary: message });
	}

	info(message: string, detail?: string): void {
		this.toast?.add({ detail, life: 3000, severity: 'info', summary: message });
	}

	warn(message: string, detail?: string): void {
		this.toast?.add({ detail, life: 4000, severity: 'warn', summary: message });
	}
}

export const notifyService = new NotifyService();
